import ReactSelect from 'react-select';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import './SetSizeTool.scss';
import { getUnit } from '../../../redux/homeActions';
import {
  getLeftDistance,
  getRightDistance,
  getTopDistance,
  getBottomDistance
} from '../../../redux/actions/canvasMeasurementHandler';
import { canvasObjectSizeIsUpdated } from '../../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import { convertImperialToGivenUnitSystem } from '../../../utilities/HelperFunctions/HelperFunctions';
import { isFurnitureLayout } from '../../../redux/fabricCanvasActionHelpers';
import { string } from '../../../localization';

export const setSizeTool = props => {
  const {
    handleCancel,
    unitSystem,
    activeObject,
    wallWidth,
    wallHeight,
    scale,
    dispatchers
  } = props;

  const selectStyle = {
    container: provided => ({
      ...provided,
      width: '50%',
      margin: '5px'
    })
  };
  const verticalOptions = [
    { value: string.TOP_KEY, label: string.TOP_KEY, id: 'top' },
    { value: string.BOTTOM_KEY, label: string.BOTTOM_KEY, id: 'bottom' }
  ];
  const HorizontalOptions = [
    { value: string.LEFT_KEY, label: string.LEFT_KEY, id: 'left' },
    { value: string.RIGHT_KEY, label: string.RIGHT_KEY, id: 'right' }
  ];

  const wallWidthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
    wallWidth,
    unitSystem
  );
  const wallHeightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
    wallHeight,
    unitSystem
  );

  const approximate = value => parseFloat(value).toFixed(2);

  const [width, setWidth] = useState(
    convertImperialToGivenUnitSystem(
      approximate(activeObject.width * activeObject.scaleX * scale),
      unitSystem
    )
  );
  const [height, setHeight] = useState(
    convertImperialToGivenUnitSystem(
      approximate(activeObject.height * activeObject.scaleY * scale),
      unitSystem
    )
  );
  const [activeVerticalOption, setActiveVerticalOption] = useState(
    verticalOptions[0]
  );
  const [activeHorizontalOption, setActiveHorizontalOption] = useState(
    HorizontalOptions[0]
  );

  const [leftDistance, setLeftDistance] = useState(
    approximate(getLeftDistance(activeObject, scale, unitSystem))
  );
  const [rightDistance, setRightDistance] = useState(
    approximate(getRightDistance(activeObject, scale, wallWidth, unitSystem))
  );
  const [horizontalDistance, setHorizontalDistance] = useState(leftDistance);

  const [topDistance, setTopDistance] = useState(
    approximate(getTopDistance(activeObject, scale, unitSystem))
  );
  const [bottomDistance, setBottomDistance] = useState(
    approximate(getBottomDistance(activeObject, scale, wallHeight, unitSystem))
  );
  const [verticalDistance, setVerticalDistance] = useState(topDistance);

  const handleHorizontalDistanceChange = value => {
    setHorizontalDistance(value);
    if (activeHorizontalOption.value == 'left') {
      setLeftDistance(value);
    } else {
      setRightDistance(value);
    }
  };

  const handleHorizontalOptionsChange = value => {
    setActiveHorizontalOption(value);
    if (value.value == 'left') {
      setHorizontalDistance(leftDistance);
    } else {
      setHorizontalDistance(rightDistance);
    }
  };

  const handleVerticalDistanceChange = value => {
    setVerticalDistance(value);
    if (activeVerticalOption.id == 'top') {
      setTopDistance(value);
    } else {
      setBottomDistance(value);
    }
  };

  const handleVericalOptionsChange = value => {
    setActiveVerticalOption(value);
    if (value.id == 'top') {
      setVerticalDistance(topDistance);
    } else {
      setVerticalDistance(bottomDistance);
    }
  };

  useEffect(() => {
    setRightDistance(wallWidthInCurrentUnitSystem - width - leftDistance);
  }, [leftDistance]);

  useEffect(() => {
    setLeftDistance(wallWidthInCurrentUnitSystem - width - rightDistance);
  }, [rightDistance]);

  useEffect(() => {
    setBottomDistance(wallHeightInCurrentUnitSystem - height - topDistance);
  }, [topDistance]);

  useEffect(() => {
    setTopDistance(wallHeightInCurrentUnitSystem - height - bottomDistance);
  }, [bottomDistance]);

  useEffect(() => {
    setRightDistance(wallWidthInCurrentUnitSystem - width - leftDistance);
  }, [width]);

  useEffect(() => {
    setTopDistance(wallHeightInCurrentUnitSystem - height - bottomDistance);
  }, [height]);

  const [errorMessage, setErrorMessage] = useState('');
  const [widthInvalid, setWidthInvalid] = useState(false);
  const [heightInvalid, setHeightInvalid] = useState(false);
  const [horizontalInvalid, setHorizontalInvalid] = useState(false);
  const [verticalInvalid, setVerticalInvalid] = useState(false);

  const inputValidation = () => {
    let message = '';
    let foundError = false;
    let widthInValid = false;
    let heightInValid = false;
    let horizontalInValid = false;
    let verticalInValid = false;

    if (Number.isNaN(width) || width <= 0) {
      foundError = true;
      message = string.ABOVE_ZERO_ERROR_TEXT_KEY;
      widthInValid = true;
    }
    if (Number.isNaN(height) || height <= 0) {
      foundError = true;
      message = string.ABOVE_ZERO_ERROR_TEXT_KEY;
      heightInValid = true;
    }
    if (Number.isNaN(horizontalDistance) || horizontalDistance < 0) {
      foundError = true;
      message = string.ABOVE_ZERO_ERROR_TEXT_KEY;
      horizontalInValid = true;
    }
    if (Number.isNaN(verticalDistance) || verticalDistance < 0) {
      foundError = true;
      message = string.ABOVE_ZERO_ERROR_TEXT_KEY;
      verticalInValid = true;
    }

    setErrorMessage(message);
    setWidthInvalid(widthInValid);
    setHeightInvalid(heightInValid);
    setHorizontalInvalid(horizontalInValid);
    setVerticalInvalid(verticalInValid);
    if (!foundError) {
      handleCancel();
      const inPosition = { left: leftDistance, top: topDistance };
      const inSize = { width, height };

      dispatchers.canvasObjectSizeIsUpdated(activeObject, inPosition, inSize);
    }
  };

  return (
    <div className='undraggable custom-set-size-width'>
      <div className='set-size-title-container'>
        <span>{string.SIZE_KEY}</span>
      </div>
      <div className='d-flex m-2'>
        <div className='set-size-label'>
          <span>{string.WIDTH_KEY}</span>
        </div>
        <div className='set-size-input-container'>
          <input
            type='number'
            value={width}
            onKeyDown={e => {
              setWidth(e.target.value);
            }}
            onChange={e => {
              setWidth(e.target.value);
            }}
            className={[
              'set-size-input',
              widthInvalid ? ' is-invalid' : null
            ].join(' ')}
          />
          <span> {getUnit(unitSystem)} </span>
        </div>
      </div>
      <div className='d-flex give-bottom-margin mx-2 mt-2'>
        <span className='set-size-label'>{string.HEIGHT_KEY}</span>
        <div className='set-size-input-container'>
          <input
            type='number'
            value={height}
            onKeyDown={e => {
              setHeight(e.target.value);
            }}
            onChange={e => {
              setHeight(e.target.value);
            }}
            className={[
              'set-size-input',
              heightInvalid ? ' is-invalid' : null
            ].join(' ')}
          />
          <span> {getUnit(unitSystem)} </span>
        </div>
      </div>
      <hr style={{ border: '1px solid' }} />
      <div className='set-size-title-container'>
        <span>{string.POSITION}</span>
      </div>
      <div className='distance-container'>
        <div className='set-size-label'>
          <span>{string.DISTANCE_FROM_KEY}</span>
        </div>
        <div className='d-flex set-size-input-container'>
          <ReactSelect
            value={activeVerticalOption}
            options={verticalOptions}
            onChange={value => handleVericalOptionsChange(value)}
            styles={selectStyle}
            isDisabled={isFurnitureLayout(activeObject)}
          />
          <input
            type='number'
            value={verticalDistance}
            onKeyDown={e => handleVerticalDistanceChange(e.target.value)}
            onChange={e => handleVerticalDistanceChange(e.target.value)}
            className={[
              'ml-1 set-size-input',
              verticalInvalid ? ' is-invalid' : null
            ].join(' ')}
            disabled={isFurnitureLayout(activeObject)}
          />
          <text className='ml-1'> {getUnit(unitSystem)} </text>
        </div>
      </div>
      <div className='distance-container give-bottom-margin'>
        <div className='set-size-label'>
          <span>{string.DISTANCE_FROM_KEY}</span>
        </div>
        <div className='d-flex set-size-input-container'>
          <ReactSelect
            value={activeHorizontalOption}
            options={HorizontalOptions}
            onChange={value => handleHorizontalOptionsChange(value)}
            styles={selectStyle}
          />
          <input
            type='number'
            value={horizontalDistance}
            onKeyDown={e => handleHorizontalDistanceChange(e.target.value)}
            onChange={e => handleHorizontalDistanceChange(e.target.value)}
            className={[
              'ml-1 set-size-input',
              horizontalInvalid ? ' is-invalid' : null
            ].join(' ')}
          />
          <text className='ml-1'> {getUnit(unitSystem)} </text>
        </div>
      </div>
      <div className='d-block error-message-custom-feilds'>{errorMessage}</div>
      <button
        type='button'
        className='btn btn-secondary btn-sm mr-1'
        style={{ width: '49%' }}
        onClick={() => handleCancel()}
      >
        {string.CANCEL_TEXT_KEY}
      </button>
      <button
        type='button'
        className='btn btn-primary btn-sm'
        style={{ width: '49%' }}
        onClick={() => {
          inputValidation();
        }}
      >
        {string.UPDATE_TEXT_KEY}
      </button>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      canvasObjectSizeIsUpdated: bindActionCreators(
        canvasObjectSizeIsUpdated,
        dispatch
      )
    }
  };
}

export default connect(null, mapDispatchToProps)(setSizeTool);
